import { Box, Button, Checkbox, containerClasses, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useRef, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import { useParams } from 'react-router-dom';
import { actualizarUsuario, postTarea, postUsuario } from '../../../services/apis';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import SquareIcon from '@mui/icons-material/Square';
import AutocompleteList from '../../../utils/componentes-utiles/AutocompleteList';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CheckIcon from '@mui/icons-material/Check';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LoopIcon from '@mui/icons-material/Loop';
import { ContasenaOculta } from '../../../utils/componentes-utiles/ContasenaOculta';
import { generarColorAleatorio, ordenarPorCampoTexto, textoMayusculas } from '../../../utils/utils';

const parseProyectosAsignados = (proyectosAsignados) => {
    let proyectos = [];

    if (Array.isArray(proyectosAsignados)) {
        proyectos = proyectosAsignados;
    } else {
        try {
            const proyectosParseados = JSON.parse(proyectosAsignados || '[]');
            proyectos = Array.isArray(proyectosParseados) ? proyectosParseados : [];
        } catch (error) {
            proyectos = [];
        }
    }

    return [...new Set([0, ...proyectos.map(Number)])];
};

export const EditarUsuario = ({ open, setOpen, cargarUsuarios, roles, departamentos, clientes, proyectos = [], usuarioData }) => {
    const handleClose = () => {
        setOpen(false);
    };
    const param = useParams();
    const [errorAlert, setErrorAlert] = useState(false);
    const [errorPassAlert, setErrorPassAlert] = useState(false);
    const [erroRespuesta, setErroRespues] = useState(false);
    const [rol, setRol] = useState(0);
    const [departamento, setDepartamento] = useState(0);
    const [camara, setCamara] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
    const [contrasena, setContrasena] = useState("");
    const [contrasenaCon, setContrasenaCon] = useState("");
    const [esCliente, setEsCliente] = useState(usuarioData.id_cliente ? true : false);
    const [recibeSa, setRecibeSa] = useState(usuarioData.sa ? true : false);
    const proyectosAsignadosIniciales = parseProyectosAsignados(usuarioData.proyectos_asignados);
    const opcionesProyectos = [
        { label: 'FEINES', value: 0 },
        ...ordenarPorCampoTexto(proyectos, 'nombre')
            .filter((proyecto) => Number(proyecto.id) !== 0)
            .map((proyecto) => ({
                label: textoMayusculas(proyecto.nombre),
                value: Number(proyecto.id)
            }))
    ];
    const [proyectosSelec, setProyectosSelec] = useState(
        opcionesProyectos.filter((proyecto) => proyectosAsignadosIniciales.includes(proyecto.value))
    );
    const [usuario, setUsuario] = useState({
        'nombre': usuarioData.nombre,
        'mail': usuarioData.mail,
        'telefono': usuarioData.telefono || '',
        'id_rol': usuarioData.rol,
        'id_departamento': usuarioData.departamento,
        'color': usuarioData.color,
        'sa': usuarioData.sa,
        'id_cliente': usuarioData.id_cliente,
        'id': usuarioData.id,
        'proyectos_asignados': proyectosAsignadosIniciales
    })


    const handleChange = (event) => {
        const tareaNueva = { ...usuario, [event.target.name]: event.target.value };
        setUsuario(tareaNueva);
        setErrorAlert(false);
    }
    
    const isNullInObject = (obj) => {
        const camposObligatorios = ['nombre', 'mail', 'id_rol', 'id_departamento', 'color'];
        return camposObligatorios.every(key => obj[key] !== null && obj[key] !== '' && obj[key] != 0);
    };
    const handleColorChange = (event) => {
        setColor(event.target.value);
    };

    //camara
    const handleFileInputChange = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            setImagenSeleccionada(reader.result);
            setCamara(true);
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };

    const fileInputRef = useRef(null);

    const handleLoopIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const handleCheckboxChange = (event) => {
        if (event.target.name === 'esCliente') {
            setEsCliente(event.target.checked);
            if (event.target.checked) {
                setRecibeSa(false); // Desactivar el otro checkbox
                setUsuario({ ...usuario, sa: 0 });
                setUsuario({ ...usuario, id_cliente: usuarioData.id_cliente });

            } else {
                setUsuario({ ...usuario, id_cliente: null });
            }
        } else if (event.target.name === 'recibeSa') {
            setRecibeSa(event.target.checked);
            if (event.target.checked) {
                setEsCliente(false); // Desactivar el otro checkbox
                setUsuario({ ...usuario, id_cliente: null });
                setUsuario({ ...usuario, sa: 1 });

            } else {
                setUsuario({ ...usuario, sa: 0 });
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let usuarioEnvio = { ...usuario };
        usuarioEnvio.proyectos_asignados = [...new Set([0, ...proyectosSelec.map((proyecto) => Number(proyecto.value))])];
        if ((contrasena === contrasenaCon)) {
            usuarioEnvio.contrasena = contrasena;
            usuarioEnvio.color = color;
            usuario.sa = recibeSa;
            const tareaComprobada = isNullInObject(usuarioEnvio);
            if (!tareaComprobada) {
                console.error("Hay campos vacíos o no válidos en el formulario");
                setErrorAlert(true);
                return; // Detener la ejecución si hay campos no válidos
            }
        } else {
            console.error("Revisa que las contraseñas coincidan o no esten vacias");
            setErrorPassAlert(true);
            return; // Detener la ejecución si hay campos no válidos
        }

        crearUsuario(usuarioEnvio);
    };
    const [color, setColor] = useState(`${usuario.color}`);
    const colorInputRef = useRef(null);
    const crearUsuario = async (usuarioEnvio) => {
        const nuevoUsuario = { ...usuarioEnvio };
        try {
            const response = await actualizarUsuario(nuevoUsuario);
            if (response.success === true) {
                cargarUsuarios();
                setUsuario({
                    'nombre': null,
                    'mail': null,
                    'telefono': '',
                    'id_rol': null,
                    'id_departamento': null,
                    'color': null,
                    'contrasena': null,
                    'sa': 0,
                });
                setDepartamento({ label: "Aginar a un Trabajador", value: "0" });
                handleClose();
            } else if (response.success === false) {
                setErroRespues(response.error);

            }
        } catch (error) {
            console.error("Error Crear el Usuario", error);
            setErroRespues(true);

        }
    };
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
            fullWidth
            maxWidth="lg"
            justifyContent="center"
            PaperProps={{
                sx: {
                    overflow: 'visible',
                    width: { xs: '96vw', md: '980px' },
                    maxWidth: '96vw'
                }
            }}
        >
            <Grid container xs={12} spacing={2} direction="row" alignItems={"center"} justifyContent={"space-between"} sx={{ px: 2, pt: 1 }}>
                <DialogTitle id="form-dialog-title">
                    Editar a {usuarioData.nombre}
                </DialogTitle>
                <div className='flex-right'>
                    <CancelIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                </div>
            </Grid>
            <DialogContent sx={{ overflow: 'visible', px: { xs: 2, sm: 3 }, pb: 1 }}>
                <form onSubmit={handleSubmit}>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', md: '240px minmax(0, 1fr)' },
                            gap: { xs: 2, md: 3 },
                            alignItems: 'start',
                            pt: 1
                        }}
                    >
                        <Box
                            sx={{
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 2,
                                minHeight: { xs: 'auto', md: 330 },
                                backgroundColor: '#fafafa'
                            }}
                        >
                            <Typography variant="subtitle2" fontWeight={700}>
                                Foto del Usuario
                            </Typography>

                            {!camara && !imagenSeleccionada && (
                                <>
                                    <AccountCircleIcon sx={{ fontSize: 78, cursor: 'pointer' }} onClick={handleLoopIconClick} />
                                    <input
                                        ref={fileInputRef}
                                        type='file'
                                        style={{ display: 'none' }}
                                        accept='image/*'
                                        onChange={handleFileInputChange}
                                    />
                                </>
                            )}
                            {(imagenSeleccionada && !camara) && (
                                <Box sx={{ display: 'flex', justifyContent: 'center', p: 1 }}>
                                    <img src={imagenSeleccionada} onClick={() => setCamara(true)} alt="Imagen seleccionada" className='miniatura-perfil-form' />
                                </Box>
                            )}

                            {(imagenSeleccionada && camara) && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, p: 1 }}>
                                    <img src={imagenSeleccionada} alt="Imagen seleccionada" className='miniatura-perfil-form' onClick={handleLoopIconClick} />
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                                        <CheckIcon className='flex-center' onClick={() => setCamara(false)} />
                                        <LoopIcon className='flex-center' onClick={handleLoopIconClick} />

                                        <input
                                            ref={fileInputRef}
                                            type='file'
                                            style={{ display: 'none' }}
                                            accept='image/*'
                                            onChange={handleFileInputChange}
                                        />

                                        <DeleteForeverIcon className='flex-center' onClick={() => { setImagenSeleccionada(null); setCamara(false); }}></DeleteForeverIcon>
                                    </Box>
                                </Box>
                            )}

                            <Box sx={{ width: '100%', borderTop: '1px solid #e0e0e0', pt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                <Typography variant="subtitle2" fontWeight={700}>
                                    Color del Usuario
                                </Typography>
                                <input
                                    type="color"
                                    ref={colorInputRef}
                                    value={color}
                                    onChange={handleColorChange}
                                    id="primary_color"
                                />
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
                                gap: 2,
                                alignItems: 'center',
                                minWidth: 0
                            }}
                        >
                            <Box>
                                <TextField
                                    label="Nombre"
                                    variant="outlined"
                                    multiline
                                    fullWidth
                                    name="nombre"
                                    value={usuario.nombre}
                                    onChange={handleChange}
                                    required
                                />
                            </Box>
                            <Box>
                                <TextField
                                    label="Mail"
                                    variant="outlined"
                                    multiline
                                    fullWidth
                                    type='mail'
                                    name="mail"
                                    value={usuario.mail}
                                    onChange={handleChange}
                                    required
                                />
                            </Box>
                            <Box>
                                <TextField
                                    label="Telefono"
                                    variant="outlined"
                                    fullWidth
                                    type='tel'
                                    name="telefono"
                                    value={usuario.telefono}
                                    onChange={handleChange}
                                />
                            </Box>
                            <Box>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Departamento</InputLabel>
                                    <Select
                                        color='primary'
                                        value={usuario.id_departamento || ''}
                                        name={"id_departamento"}
                                        onChange={handleChange}
                                        defaultValue="Departamento"
                                        label="Departamento"
                                        fullWidth
                                    >
                                        {ordenarPorCampoTexto(departamentos, 'nombre').map((departamento) => (
                                            <MenuItem
                                                key={departamento.id}
                                                value={departamento.id}
                                                onChange={handleChange}
                                            >
                                                {textoMayusculas(departamento.nombre)}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Rol</InputLabel>
                                    <Select
                                        color='primary'
                                        value={usuario.id_rol || ''}
                                        name={"id_rol"}
                                        onChange={handleChange}
                                        defaultValue="Rol"
                                        label="Rol"
                                        fullWidth
                                    >
                                        {ordenarPorCampoTexto(roles, 'nombre').map((rol) => (
                                            <MenuItem
                                                key={rol.id}
                                                value={rol.id}
                                                onChange={handleChange}
                                            >
                                                {textoMayusculas(rol.nombre)}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Box>
                            <Box>
                                <ContasenaOculta contrasena={contrasena} setContrasena={setContrasena}></ContasenaOculta>
                            </Box>
                            <Box>
                                <ContasenaOculta contrasena={contrasenaCon} setContrasena={setContrasenaCon}></ContasenaOculta>
                            </Box>
                            <Box sx={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 1 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={esCliente}
                                            onChange={handleCheckboxChange}
                                            name="esCliente"
                                        />
                                    }
                                    label="Es Cliente"
                                />
                                { }
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={recibeSa}
                                            onChange={handleCheckboxChange}
                                            name="recibeSa"
                                        />
                                    }
                                    label="Recibe SA"
                                />
                            </Box>
                            {!esCliente && (
                                <Box sx={{ gridColumn: '1 / -1', position: 'relative', zIndex: 5, mt: 1 }}>
                                    <AutocompleteList
                                        array={opcionesProyectos}
                                        setArray={setProyectosSelec}
                                        arrayPre={proyectosSelec}
                                        label="Proyectos asignados"
                                    />
                                </Box>
                            )}
                            {esCliente && (

                                <Box sx={{ gridColumn: { xs: '1 / -1', sm: 'span 1' } }}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Cliente</InputLabel>
                                        <Select
                                            color='primary'
                                            value={usuario.id_cliente || ''}
                                            name={"id_cliente"}
                                            onChange={handleChange}
                                            defaultValue="Cliente"
                                            label="Cliente"
                                            fullWidth
                                        >
                                            {ordenarPorCampoTexto(clientes, 'nombre').map((cliente) => (
                                                <MenuItem
                                                    key={cliente.id}
                                                    value={cliente.id}
                                                    onChange={cliente}
                                                >
                                                    {textoMayusculas(cliente.nombre)}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </form>
            </DialogContent >

            <DialogActions style={{
                // backgroundColor: "#" + backgroundCard,
                // color: textColor
            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained" disabled={
                    usuario.nombre === usuarioData.nombre &&
                    usuario.mail === usuarioData.mail &&
                    usuario.telefono === (usuarioData.telefono || '') &&
                    usuario.id_rol === usuarioData.rol &&
                    usuario.id_departamento === usuarioData.departamento &&
                    usuario.color === color &&
                    usuario.sa === usuarioData.sa &&
                    usuario.id_cliente === usuarioData.id_cliente &&
                    JSON.stringify([...new Set([0, ...proyectosSelec.map((proyecto) => Number(proyecto.value))])].sort()) === JSON.stringify([...proyectosAsignadosIniciales].sort()) &&
                    contrasena === ""
                }>
                    Editar Usuario
                </Button>

            </DialogActions>
            {
                errorAlert && (
                    <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Falta rellenar algún campo obligatorio"} />
                )

            }
            {
                errorPassAlert && (
                    <AlertError open={errorPassAlert} setOpen={setErrorPassAlert} titulo={"Error"} mensaje={"Las contraseñas no coinciden"} />
                )

            }
            {
                erroRespuesta && (
                    <AlertError open={erroRespuesta} setOpen={setErroRespues} titulo={"Error"} mensaje={erroRespuesta} />
                )
            }
        </Dialog >
    );
};
